module.exports = __webpack_public_path__ + "media/images/icon-original-0da4b761efa093fb788c43901c66f1be.svg";